import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import ColorSelectorDot from "./ColorSelectorDot";
import "./colorSelector.scss";
export const ColorSelector = ({ config, onChange, value, className, testId }) => {
    const onClick = (element) => () => {
        onChange(element);
    };
    return (_jsx("div", { className: classNames({
            "color-selector": true,
            "color-selector--active": !!value,
            className,
        }), "data-testid": testId, children: config.map((element) => {
            return (_jsx(ColorSelectorDot, { color: element.color, isInStock: element.isInStock, onClick: onClick(element), active: element.value === value }, element.color));
        }) }));
};
